import React from "react"
import DispatchHeader from "./DispatchHeader"
import DispatchMap from "./DispatchMap"

const DispatchMapPage = () => {
  return (
    <>
      <DispatchHeader />
      <DispatchMap />
    </>
  )
}

export default DispatchMapPage
